module.exports = __webpack_public_path__ + "img/TV_clean_box04.20c4bea6.jpg";